module.exports = __webpack_public_path__ + "static/media/education-square.86105b86.jpg";